var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2093 46.5996C51.414 48.8509 48.2526 50.7133 45.7314 51.258C44.0055 51.6244 41.7549 51.9142 34.1715 48.7717C25.6542 45.2429 13.827 32.6732 13.827 24.3085C13.827 20.0502 16.2822 15.0917 20.5755 15.0917C22.6413 15.0917 23.0967 15.132 23.7765 16.7626C24.5718 18.6838 26.5122 23.4172 26.7432 23.9024C27.6969 25.8929 25.773 27.0582 24.3771 28.7912C23.9316 29.3127 23.4267 29.8768 23.991 30.8473C24.552 31.798 26.4924 34.9604 29.3436 37.4988C33.0264 40.78 36.0129 41.8276 37.0821 42.2732C37.8774 42.6033 38.8278 42.5264 39.4086 41.9058C40.1445 41.1103 41.0586 39.7904 41.9892 38.4898C42.6459 37.5589 43.4808 37.4427 44.3553 37.7728C44.946 37.9774 52.4535 41.464 52.7703 42.0218C53.0046 42.4279 53.0046 44.3483 52.2093 46.5996ZM33.0066 0H32.9901C14.7972 0 0 14.8017 0 33C0 40.216 2.32652 46.9106 6.28322 52.3408L2.17142 64.603L14.8533 60.5505C20.0706 64.0033 26.2977 66 33.0066 66C51.1995 66 66 51.1983 66 33C66 14.8017 51.1995 0 33.0066 0Z",
    fill: "#FFDFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.ca0fec6758606305c163a2e72c2ae223.svg";
export { ForwardRef as ReactComponent };